import React from 'react'

const HowItWorks = () => {
  return (
    <section className='relative overflow-hidden  flex flex-col w-full items-center w-full pt-28' id="choose-style">

      <svg className='absolute overflow-hidden -z-10 top-16 left-16' version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="438px" height="438px" viewBox="0 0 438 438" enableBackground="new 0 0 438 438" >
        <path id="circle" fill="none" stroke="#FCE5ED" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" d="M418,219
    c0,109.9-89.1,199-199,199S20,328.9,20,219S109.1,20,219,20S418,109.1,418,219L418,219z"></path>
      </svg>
      <svg className='absolute -z-10 top-2/3	 md:top-1/3 lg:top-20 -right-16' version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="578px" height="411px" viewBox="0 0 578 411" enableBackground="new 0 0 578 411" >
        <polygon id="triangle" fill="none" stroke="#D1F9F4" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" points="
    426.8,389.2 554.4,21.8 23.6,62 "></polygon>
      </svg>
      <svg className='hidden md:block absolute -z-10 top-2/4 left-0' version="1.1" id="bg-lines" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="575px" height="479px" viewBox="0 0 575 479" enableBackground="new 0 0 575 479" >
        <path id="lines" fill="none" stroke="#FEF5DD" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" d="M20,266.6
    L376.3,20 M107.8,362.5l356.3-246.6 M198.2,458.3l356.3-246.6"></path>
      </svg>

      <div className="w-full m-auto text-center">
        <h2 className="font-tiempo text-azul font-semibold text-5xl">
          How it works
        </h2>
        <p className='font-basis font-bold text-gray-1 text-center px-8 py-4 md:w-3/5 mx-auto text-xl'>
          Select a packaging style, quantity, and choose from custom or stock sizes – then start designing your custom boxes. Add customization options like images, text, and any color your brand requires. As you design you'll see an instant quote so you know exactly what your final order will come to.
        </p>
      </div>
      <div>
        <div className="w-96 h-96 bg-black flex justify-center items-center my-48 text-white text-4xl">
          Coming soon
        </div>
      </div>
      <div className='flex flex-col lg:flex-row font-basis font-bold text-gray-1 max-w-screen-2xl w-4/5 text-center mb-28' >
        <div className='flex-1'>
          <div className='img-condition'>
            <picture><img className=' block w-full' alt="Tiny minimums. No maximums." src="https://assets.packlane.com/images/infinity-icon.svg" /></picture>
          </div>
          <h4 className="azul text-2xl lg:px-16">Tiny minimums.<br /> No maximums.</h4>
          <p className="text-xl	lg:px-8 " >No matter the size of your custom packaging order, you'll get the best boxes at prices to match.</p>
        </div>
        <div className='flex-1'>
          <div className='img-condition'>
            <picture><img className='block w-full' alt="Instant quotes" src="https://assets.packlane.com/images/ico-quote.svg" /></picture>
          </div>
          <h4 className="azul text-2xl lg:px-16">Instant quotes</h4>
          <p className="text-xl	 lg:px-8 " >Pick your style, design your boxes, and get an instant quote.</p>
        </div>
        <div className='flex-1'>
          <div className='img-condition'>
            <picture><img className='block w-full' alt="Fast turnarounds" src="https://assets.packlane.com/images/ico-fast.svg" /></picture>
          </div>
          <h4 className="azul text-2xl lg:px-16 ">Fast turnarounds</h4>
          <p className="text-xl	lg:px-8 " >Eligible orders may ship within 10 days or less with priority turnaround options.</p>
        </div>
      </div>

    </section>
  )
}

export default HowItWorks
